var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlanboardInfo = function SvgPlanboardInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#007AFF",
    d: "M4.07 2.805a1.24 1.24 0 0 1-1.242-1.25A1.24 1.24 0 0 1 4.07.313a1.24 1.24 0 0 1 1.242 1.242c0 .695-.554 1.25-1.242 1.25M.36 14.765c0-.343.296-.609.68-.609h2.663V6.867H1.328c-.39 0-.695-.273-.695-.633 0-.336.305-.601.695-.601h3.149a.69.69 0 0 1 .68.703v7.82h2.202c.375 0 .68.266.68.61s-.305.625-.68.625H1.04c-.383 0-.68-.282-.68-.625"
  })));
};
export default SvgPlanboardInfo;